// The collection screen's persisted sort (cb.collection.sort.v1), read
// without React or the API layer: the screen (collectionDisplay), the
// first-page prefetch and the offline runtime's provisional first page all
// read the SAME choice through readSort, so the page painted from this device
// is always the page the screen is about to ask for.
//
// A device preference (a sort name and a direction), never owner data.
import { COPY_SORTS, DEFAULT_DIR, SORT_DIRS, STORAGE, type CopySort, type SortDir } from '../api/collectionCopies.codes'

export interface CollectionSort {
  sort: CopySort
  dir: SortDir
}

/** New users: value, high to low. */
export const DEFAULT_SORT: CollectionSort = { sort: COPY_SORTS[2], dir: DEFAULT_DIR[COPY_SORTS[2]] }

export function readSort(): CollectionSort {
  let raw: Record<string, unknown> | null = null
  try {
    const s = localStorage.getItem(STORAGE.sort)
    const v = s ? (JSON.parse(s) as unknown) : null
    raw = v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : null
  } catch {
    raw = null
  }
  if (!raw || !(COPY_SORTS as readonly unknown[]).includes(raw.sort)) return DEFAULT_SORT
  const sort = raw.sort as CopySort
  const dir = (SORT_DIRS as readonly unknown[]).includes(raw.dir) ? (raw.dir as SortDir) : DEFAULT_DIR[sort]
  return { sort, dir }
}
